/**
 * QUE PESTANA DE LA BIBLIOTECA SE MIRA, LEIDA DE LA URL.
 *
 * Antes era un `useState` y por eso recargar te devolvia a Capturas, y no habia
 * forma de enlazar Social Data desde ningun sitio. El propietario pidio
 * justamente eso: un boton de Social Data en la barra de abajo y otro en el
 * desplegable de arriba, y un destino que no se puede nombrar en una URL no se
 * puede poner en un boton.
 *
 * Funciones puras y en su propio archivo para poder probarlas con `node:test`
 * sin montar nada (SPEC 20: cero dependencias de test en `web/`).
 *
 * LO QUE NO SE RECONOCE CAE EN CAPTURAS, nunca en una pantalla en blanco. La URL
 * la escribe cualquiera -- un enlace viejo, un dedo en la barra del navegador, un
 * marcador de cuando la pestana se llamaba de otra forma --, y una seccion
 * inventada tiene que comportarse como entrar a la Biblioteca sin pedir nada.
 */

export type LibrarySection = "capturas" | "estudios" | "social";

/** La que se mira al entrar sin pedir ninguna. */
export const DEFAULT_SECTION: LibrarySection = "capturas";

const SECTIONS: readonly LibrarySection[] = ["capturas", "estudios", "social"];

/** El nombre del parametro, escrito UNA vez: lo leen la pantalla y los enlaces. */
export const SECTION_PARAM = "seccion";

export function sectionFrom(value: string | null | undefined): LibrarySection {
  return SECTIONS.find((section) => section === value) ?? DEFAULT_SECTION;
}

/**
 * La URL de una seccion. Capturas va SIN parametro: es la de entrada, y
 * arrastrar `?seccion=capturas` por los enlaces haria que la Biblioteca y la
 * Biblioteca-en-capturas fueran dos direcciones distintas para lo mismo.
 */
export function sectionUrl(section: LibrarySection): string {
  return section === DEFAULT_SECTION
    ? "/biblioteca"
    : `/biblioteca?${SECTION_PARAM}=${section}`;
}
